export const SET_PICKUP_FORM = '[Pickup form] Set Details from lot';
export const UPDATE_PICKUP_FORM = '[Pickup form] Update on change';
export const HANDLE_PICKUP_FORM_FIELD_CHANGE = '[Pickup form] Handle Field Changes';
export const PICKUP_FROM_SUBMISSION = '[Pickup form] Submission';
export const PICKUP_FROM_SUBMISSION_SUCCESS = '[Pickup form] Submission success';
export const PICKUP_FROM_SUBMISSION_ERROR = '[Pickup form] Submission Error';
export const SET_ADDRESS_TO_PICKUPFORM = '[Pickup form] Set Address to Pickup form';
export const SET_CURRENT_STEP_ERROR = "[Pickup form] set current step error";
export const CHECK_ERROR_IN_CURRENT_STEP = "[Pickup form] set error";

export const handlePickupFormChange = (name, value, error) => ({
  type: HANDLE_PICKUP_FORM_FIELD_CHANGE,
  payload: { key: name, value: value, error: error }
});



// WEBPACK FOOTER //
// ./src/redux/actions/pickupForm.js